(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );
      this.stickyAddButton = null;
      this.isSubmitting = false; // Flag to prevent double submission

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
      
      // Initialize sticky button after a short delay to ensure DOM is ready
      setTimeout(() => this.initializeStickyButton(), 100);
    }

    initializeStickyButton() {
      // Find the sticky add button in the product bar
      this.stickyAddButton = this.productBar?.querySelector('[name="add"]');
      
      if (this.stickyAddButton) {
        // Remove any existing click events first
        const newButton = this.stickyAddButton.cloneNode(true);
        this.stickyAddButton.parentNode.replaceChild(newButton, this.stickyAddButton);
        this.stickyAddButton = newButton;
        
        // Add click handler for sticky button
        this.stickyAddButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          // Prevent double submission
          if (this.isSubmitting) return;
          
          // Trigger the main form submission
          this.triggerFormSubmission();
        });
        
        console.log('Sticky button initialized and connected to main form');
      }
    }

    triggerFormSubmission() {
      // Prevent multiple submissions
      if (this.isSubmitting) return;
      
      // Set submitting flag
      this.isSubmitting = true;
      
      // Disable both buttons
      this.toggleButtons(true);
      
      // Manually call the form submission handler
      this.onSubmitHandler(new Event('submit'));
    }

    onSubmitHandler(event) {
      event.preventDefault();
      
      // If already submitting via sticky button, skip the default form submission
      if (this.isSubmitting) {
        this.isSubmitting = false;
      }
      
      const purchaseOptions = document.querySelector('purchase-options');
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        this.toggleButtons(false);
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          // Update cart drawer
          if (this.cartDrawer && this.cartDrawer.renderContents) {
            this.cartDrawer.renderContents(response);
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          this.handleErrorMessage('Something went wrong. Please try again.');
        })
        .finally(() => {
          // Re-enable buttons and reset flag
          this.toggleButtons(false);
          this.isSubmitting = false;
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;

      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }

      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }

    toggleButtons(disable) {
      // Handle main form button
      if (this.submitButton) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.classList.add('disabled');
          this.submitButton.textContent = window.variantStrings?.adding || 'Adding...';
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.classList.remove('disabled');
          this.submitButton.textContent = this.hasAttribute('data-has-selling-plan')
            ? (window.variantStrings?.addSubscriptionToCart || 'Add subscription to cart')
            : (window.variantStrings?.addToCart || 'Add to cart');
        }
      }

      // Handle sticky bar button
      if (this.stickyAddButton) {
        if (disable) {
          this.stickyAddButton.setAttribute('disabled', 'disabled');
          this.stickyAddButton.classList.add('disabled');
          this.stickyAddButton.textContent = window.variantStrings?.adding || 'Adding...';
        } else {
          this.stickyAddButton.removeAttribute('disabled');
          this.stickyAddButton.classList.remove('disabled');
          this.stickyAddButton.textContent = this.hasAttribute('data-has-selling-plan')
            ? (window.variantStrings?.addSubscriptionToCart || 'Add subscription to cart')
            : (window.variantStrings?.addToCart || 'Add to cart');
        }
      }
    }
  }

  customElements.define('product-form', ProductForm);
})();